module.exports = __webpack_public_path__ + "953193efe3dce3aaee91d0ed3e2d5fa8.png";